import { Button, Text } from "@chakra-ui/react";
import { useGetRawMediaSurveysDataMutation } from "../../store/services/mediaApi";

export function downloadCsv(data, filename, fields = null) {
  if (!data || data.length === 0) return;

  const headerKeys = fields && fields.length > 0
    ? fields
    : Object.keys(data[0]);

  const escapeCell = (cell) => {
    const str = cell == null ? "" : String(cell);
    return `"${str.replace(/"/g, '""')}"`;
  };

  const csvRows = [
    headerKeys.map(escapeCell).join(","), // header row
    ...data.map((row) =>
      headerKeys.map((key) => escapeCell(row[key])).join(",")
    ),
  ];

  const blob = new Blob([csvRows.join("\r\n")], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function flattenData(data) {
  if (!Array.isArray(data) || data.length === 0) return data;

  // Step 1: Detect array-of-object keys and gather subkeys and max lengths
  const arrayMeta = {}; // { key: { maxLength: 2, subKeys: Set(...) } }

  data.forEach((row) => {
    Object.entries(row).forEach(([key, val]) => {
      if (Array.isArray(val) && val.length > 0 && typeof val[0] === 'object') {
        if (!arrayMeta[key]) {
          arrayMeta[key] = { maxLength: 0, subKeys: new Set() };
        }
        arrayMeta[key].maxLength = Math.max(arrayMeta[key].maxLength, val.length);
        val.forEach((obj) => {
          Object.keys(obj || {}).forEach((subKey) => arrayMeta[key].subKeys.add(subKey));
        });
      }
    });
  });

  // Step 2: Build flattened data rows with consistent keys
  return data.map((row) => {
    const flattened = { ...row };

    // Remove the array fields since we'll flatten them
    Object.keys(arrayMeta).forEach((arrayKey) => {
      delete flattened[arrayKey];
    });

    // Add flattened fields for each array key
    Object.entries(arrayMeta).forEach(([arrayKey, { maxLength, subKeys }]) => {
      const arr = Array.isArray(row[arrayKey]) ? row[arrayKey] : [];

      for (let i = 0; i < maxLength; i++) {
        const obj = arr[i] || {};

        subKeys.forEach((subKey) => {
          flattened[`${subKey}_${i + 1}`] = obj[subKey] ?? "";
        });
      }
    });

    return flattened;
  });
}

export function DownloadCsvButton({ id, filters }) {
  const [
    fetchRaw,
    { data: rawData, isLoading: isRawLoading, error: rawError },
  ] = useGetRawMediaSurveysDataMutation();

  const handleDownload = async () => {
    try {
      const stored = localStorage.getItem(`surveyFilters-${id}`);
      const initialFilters = stored ? JSON.parse(stored) : [];

      const result = await fetchRaw({ id, filters }).unwrap();

      console.log("result", result);
      if (result && result.length) {
        downloadCsv(result, `survey-data-${id}.csv`);
      }
    } catch (e) {
      console.error("Error fetching raw data", e);
    }
  };

  if (rawError) return <Text color="red.500">Error loading data</Text>;

  return (
    <Button onClick={handleDownload} isLoading={isRawLoading}>
      Download CSV
    </Button>
  );
}
